import { ListingSection } from 'listing-details/types';
import { buildCombinedVirtualTours } from 'listing-details/helpers';
import {
    CTAs,
    ListingMoreInformationFragment
} from 'listing-details/components/ListingMoreInformation/ListingMoreInformation.types';

export const getCTAs = (
    {
        additionalLinks,
        content,
        embeddedContent,
        epc,
        location,
        marketStats
    }: ListingMoreInformationFragment,
    listingSection: ListingSection,
    availableCtas: CTAs
) => {
    const requiredCtas = [];

    if (content?.floorPlan?.length) {
        requiredCtas.push(availableCtas['floorplans']);
    }

    const { tours, videos, links } = embeddedContent || {};
    const hasVirtualTours = Boolean(
        buildCombinedVirtualTours(tours || [], videos || [], links || []).length
    );

    if (hasVirtualTours) {
        requiredCtas.push(availableCtas['tours']);
    }

    if (embeddedContent?.smartViewings?.length) {
        requiredCtas.push(availableCtas['smart_viewing']);
    }

    requiredCtas.push(availableCtas['listing_history']);

    if (additionalLinks?.length) {
        requiredCtas.push(availableCtas['additional_links']);
    }

    if (location?.coordinates?.latitude) {
        requiredCtas.push(availableCtas['streetview']);
    }

    if (epc?.image?.length || epc?.pdf?.length) {
        requiredCtas.push(availableCtas['energy']);
    }

    const marketStatsRequired = (() => {
        const hasRentalEstimate = Boolean(
            marketStats?.askingPrices?.toRent.meanValue
        );
        const hasHistoricalEstimates = Boolean(
            marketStats?.historicalEstimates?.length
        );
        const hasSales = Boolean(marketStats?.sales?.length);
        const hasRecentSales = Boolean(marketStats?.recentSales?.length);

        if (listingSection === 'to-rent') {
            return hasRentalEstimate;
        }

        return (
            hasHistoricalEstimates ||
            hasSales ||
            hasRecentSales ||
            hasRentalEstimate
        );
    })();

    if (marketStatsRequired) {
        requiredCtas.push(availableCtas['market_stats']);
    }

    requiredCtas.push(availableCtas['report_listing']);

    return requiredCtas;
};
